import React from 'react';
import SearchIcon from '../../assets/icons/SearchIcon';
import './SearchButton.css';

const SearchButton = ({ onClick }) => {
    return (
        <button className="search-button" onClick={onClick} aria-label="Search">
            <SearchIcon />
        </button>
    );
};

export default SearchButton;